// EspejoFranja — W2 FASE B (21-sep-2026). La franja de FRESCURA de la copia
// local que Catálogo e Inventario muestran: edad de la copia, advertencia
// visible cuando dejó de ser confiable, CTA de migración si el espejo está
// vacío, y el botón «Actualizar» que relee de la tienda SOLO los productos
// visibles (carril interactivo) — nunca el catálogo entero.
import React, { useState } from 'react';

// `estado`: texto de progreso/resultado que llega de AFUERA cuando el botón que
// dispara el releer vive en otro lado (Catálogo: el «Actualizar» del encabezado
// — hotfix 22-sep: dos botones iguales confunden; la franja queda informativa).
// `sujeto`: qué sincroniza esta franja («productos» en Catálogo/Inventario,
// «pedidos» en Pedidos/Resumen — W3) — solo cambia el texto del estado vacío.
export default function EspejoFranja({ espejoInfo, idsVisibles = [], onReleerVisibles, onMigrarEspejo, estado = null, sujeto = 'productos' }) {
  const [actualizando, setActualizando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [migrando, setMigrando] = useState(false);
  if (!espejoInfo) return null;

  // Espejo VACÍO (tienda nueva o formato viejo completo): se DICE y se ofrece la
  // migración — nunca se cae en silencio a la tienda en vivo.
  if (espejoInfo.vacio) {
    return (
      <div className="espejo-franja espejo-franja--vacia" role="alert">
        Los datos de la tienda todavía no se sincronizaron (primer arranque o formato viejo). Los {sujeto} van a aparecer cuando corra la primera sincronización.
        <button
          type="button" className="espejo-btn"
          disabled={migrando}
          onClick={async () => { setMigrando(true); try { await onMigrarEspejo(); } finally { /* el reconciliador corre en fondo */ } }}
        >
          {migrando ? 'Sincronización arrancada — tarda unos minutos…' : 'Sincronizar ahora'}
        </button>
      </div>
    );
  }

  const actualizar = async () => {
    if (!onReleerVisibles || !idsVisibles.length || actualizando) return;
    setActualizando(true); setResultado(null);
    try {
      const r = await onReleerVisibles(idsVisibles);
      setResultado(r && typeof r.releidos === 'number' ? `${r.releidos} actualizados${(r.fallidos || []).length ? ` · ${r.fallidos.length} fallaron` : ''}` : null);
    } catch (e) {
      setResultado(`No se pudo actualizar: ${e.message}`);
    } finally {
      setActualizando(false);
    }
  };

  // EL AVISO DE FRESCURA («Datos de la tienda · actualizados/atrasados/actualizando… hace X») SE
  // QUITÓ (decisión de Miguel, 27-sep-2026): confundía en producción — decía «hace 30 h» con los
  // pedidos al día, porque medía la EDAD DEL ÚLTIMO CAMBIO del espejo (`espejadoEn` del doc más
  // nuevo), no si la sincronización está corriendo. NO era la única señal de una falla real de
  // sincronización: el estado de veras (webhooks, retraso del cron, última comparación de
  // productos/pedidos/clientes) se ve en Configuración → «Sincronización con la tienda»
  // (SincronizacionTiendaCard / GET /api/webhooks/estado). Acá quedan SOLO piezas que NO son ese
  // aviso: el CTA de tienda nueva (arriba) y —donde exista— el botón «Actualizar» con su resultado
  // y el `estado` externo (feedback del «Actualizar» del encabezado de Catálogo/Inventario).
  if (!onReleerVisibles && !estado) return null;
  return (
    <div className="espejo-franja" role="status">
      {onReleerVisibles && (
        <button type="button" className="espejo-btn" onClick={actualizar} disabled={actualizando || !idsVisibles.length}>
          {actualizando ? `Actualizando los ${idsVisibles.length} visibles…` : 'Actualizar'}
        </button>
      )}
      {resultado && <span className="espejo-resultado">{resultado}</span>}
      {estado && <span className="espejo-resultado">{estado}</span>}
    </div>
  );
}
